import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'inversor',
  type: 'node--inversor',
  attributes: {
    title: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nombre_inversor',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'apellidos_inversor',
    },
    cp: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'codigo_postal',
    },
    direccion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'direccion_inversor',
    },
    dni: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'dni_inversor',
    },
    email: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'email_inversor',
    },
    observaciones: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'observaciones_inversor',
    },
    poblacion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'poblacion_inversor',
    },
    tel1: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'telefono_1',
    },
    tel2: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'telefono_2',
    },
  },
  relationships: {
    comunidad: {
      type: 'taxonomy_term--comunidades',
      required: false,
      isArray: false,
      name: 'comunidad_autonoma',
    },
    provincia: {
      type: 'taxonomy_term--provincias',
      required: false,
      isArray: false,
      name: 'provincia_inversor',
    },
    estadoCivil: {
      type: 'taxonomy_term--civil_state',
      required: false,
      isArray: false,
      name: 'estado_civil_inversor',
    },
    tipoPersona: {
      type: 'taxonomy_term--person',
      required: false,
      isArray: false,
      name: 'tipo_persona',
    },
  },
};

export const InversorService = createService(base, configuration, API_CONFIG.API);
export const InversorModule = createModule(InversorService, true);



// WEBPACK FOOTER //
// ./src/models/inversor.js